import { AfterContentInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'app-tools',
    templateUrl: './tools.component.html',
    styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements AfterContentInit {

    @ViewChild('area') private areaRef: ElementRef<any>;
    @ViewChild('distance') private distanceRef: ElementRef<any>;
    @ViewChild('coordinates') private coordinatesRef: ElementRef<any>;
    @ViewChild('calloutTool') private calloutTool: ElementRef<any>;
    @ViewChild('calloutToolWindow') private calloutToolWindow: ElementRef<any>;
    @ViewChild('measureToolsWindow') private measureToolsWindow: ElementRef<any>;
    @ViewChild('print') private readonly print: ElementRef<any>;
    @ViewChild('printWindow') private readonly printWindow: ElementRef<any>;
    @ViewChild('streetViewWindow') private streetViewWindow: ElementRef<any>;
    @ViewChild('videoLogWindow') private videoLogWindow: ElementRef<any>;
    @ViewChild('tabs') private tabsRef: ElementRef<any>;

    @Input() visible: boolean;
    streetViewInitialized: boolean;
    videoLogInitialized: boolean;
    zoomOnPositionChange : boolean = false;
    markerSymbol = {
        type: 'simple-marker',
        style: 'circle',
        outline: {
            width: 2,
            color: 'red'
        }
    };
    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private utilsService: UtilsService,
    ) { }

    ngAfterContentInit() {
        this.closeToolsOnClick();
    }

    get tooltipsTextOnOrOff(): string {
        const tooltipEnabled = this.utilsService.tooltip && this.utilsService.tooltip.nativeElement.tooltipEnabled;
        return tooltipEnabled ? 'Off' : 'On';
    }

    closeToolsOnClick() {
        const body = document.getElementsByTagName('body')[0];
        body.addEventListener('click', (e: any) => {
            const pathClases = e.path.map(x => x.className);
            if (pathClases.indexOf('btn tools') < 0) {
                this.visible = false;
            }
        });
    }

    onCalloutBoxWindowOpenChange(e) {
        if (!e.detail) {
            (<any>this.calloutTool).nativeElement.active = false;
            this.utilsService.identify.nativeElement.activate();
        }
    }

    onMeasureToolWindowOpenChange(e) {
        if (!e.detail) {
            this.areaRef.nativeElement.active = false;
            this.distanceRef.nativeElement.active = false;
            this.coordinatesRef.nativeElement.active = false;
            this.utilsService.identify.nativeElement.activate();
            (<any>this.measureToolsWindow).nativeElement.active = false;
        }
    }

    onMeasureToolsTabChanged(e) {
        const refs = {
            'Area': this.areaRef,
            'Coordinates': this.coordinatesRef,
            'Distance': this.distanceRef
        };
        for (const ref of Object.keys(refs)) {
            refs[ref].nativeElement.active = ref === e.detail.name;
        }
    }

    onPrintWindowOpenChange(e) {
        if (!e.detail) {
            this.utilsService.identify.nativeElement.activate();
            (<any>this.print).nativeElement.active = false;
        }
    }

    onStreetViewWindowOpenChange(e) {
        if (!e.detail) {
            (<any>this.streetViewWindow).nativeElement.active = false;
        }
    }

    onVideoLogWindowOpenChange(e) {
        if (!e.detail) {
            (<any>this.videoLogWindow).nativeElement.active = false;
        }
    }

    openCalloutBox() {
        this.utilsService.identify.nativeElement.deactivate();
        this.calloutToolWindow.nativeElement.open();
        (<any>this.calloutTool).nativeElement.active = true;
    }

    openMeasureTools() {
        this.utilsService.identify.nativeElement.deactivate();
        this.measureToolsWindow.nativeElement.open();
        this.tabsRef.nativeElement.activateTab('Distance');
        this.distanceRef.nativeElement.active = true;
    }

    openPrint() {
        this.utilsService.identify.nativeElement.deactivate();
        this.printWindow.nativeElement.open();
        this.print.nativeElement.active = true;
    }

    openStreetView() {
        if (!this.streetViewInitialized) {
            const streetView: any = document.getElementById('streetView');
            const latLongSelect: any = document.getElementById('latLongSelect');
            const rmsSelect: any = document.getElementById('rmsSelect');

            this.streetViewWindow.nativeElement.addEventListener('openChange', e => {
                streetView.active = e.detail;
            });

            streetView.addEventListener('positionChange', (position) => {
                latLongSelect.setAttribute('lat', position.detail.latitude);
                latLongSelect.setAttribute('long', position.detail.longitude);
                rmsSelect.position = position.detail;
            });

            latLongSelect.addEventListener('latChange', (lat) => {
                streetView.setAttribute('lat', lat.detail);
            });

            latLongSelect.addEventListener('longChange', (long) => {
                streetView.setAttribute('long', long.detail);
            });

            rmsSelect.addEventListener('rmsChange', (rms) => {
                streetView.setRms(rms.detail);
            });
        }
        this.streetViewWindow.nativeElement.open();
    }

    openVideoLog() {
        this.zoomOnPositionChange = false;
        if (!this.videoLogInitialized) {
            const videoLog: any = document.getElementById('videoLog');
            this.utilsService.videoLogWindow = this.videoLogWindow;
            this.videoLogWindow.nativeElement.addEventListener('openChange', e => {
                videoLog.active = e.detail;
            });
            this.videoLogInitialized = true;
        }
        this.videoLogWindow.nativeElement.open();
    }
    toggleTooltips() {
        this.utilsService.tooltip.nativeElement.tooltipEnabled = !this.utilsService.tooltip.nativeElement.tooltipEnabled;
    }

}
